import type { IntlShape } from 'react-intl'
import { formatCurrency } from 'lib/format/formatCurrencyIntl'

function getOverridePromoDisplayPrompt(intl: IntlShape, path: string, query: string): App.PromoDisplayConfig | undefined {
  // https://luxuryescapes.com/gb/search?destinationName=Mauritius&destinationId=&adults=2&children=none&pages=2
  const discountValue = formatCurrency(50, 'GBP', 'GB', { format: 'roundedDollar' })
  const headerText = intl.formatMessage(
    {
      id: '2RZiGFE3ivO5BUcxtuoI',
      defaultMessage: 'Use FLYWITHUS at checkout to get {discountValue} off',
    },
    { discountValue },
  )
  const overrideDestinationIds = new Map<string, App.PromoDisplayConfig>([
    ['le_43baa6762fa81bb43b39c62553b2970d', {
      headerText,
      bodyText: intl.formatMessage(
        {
          id: '0ZK4L6VJo0P7Nqko5-IZ',
          defaultMessage: 'Bundle your hotel with a flight to receive {discountValue} off your Dubai dream escape!',
        },
        { discountValue },
      ),
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      displayOptionKey: '',
      delayDuration: 1,
      needsOfferCheck: true,
      expiresAt: '',
      passOfferCheck: {},
    }], // Dubai
    ['le_2723d092b63885e0d7c260cc007e8b9d', {
      headerText,
      bodyText: intl.formatMessage(
        {
          id: 'jHKb0NSm7uNzGJ_s31s5',
          defaultMessage: 'Bundle your hotel with a flight to receive {discountValue} off your Maldives dream escape!',
        },
        { discountValue },
      ),
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      displayOptionKey: '',
      delayDuration: 1,
      needsOfferCheck: true,
      expiresAt: '',
      passOfferCheck: {},
    }], // Maldives
    ['le_2b44928ae11fb9384c4cf38708677c48', {
      headerText,
      bodyText: intl.formatMessage(
        {
          id: 'HqTeojRNoMDvx9pztNgd',
          defaultMessage: 'Bundle your hotel with a flight to receive {discountValue} off your Mauritius dream escape!',
        },
        { discountValue },
      ),
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      displayOptionKey: '',
      delayDuration: 1,
      needsOfferCheck: true,
      expiresAt: '',
      passOfferCheck: {},
    }], // Mauritius
    ['le_5878a7ab84fb43402106c575658472fa', {
      headerText,
      bodyText: intl.formatMessage(
        {
          id: 'tAX4DcGLzZ8oJiMOB7X_',
          defaultMessage: 'Bundle your hotel with a flight to receive {discountValue} off your Sri Lanka dream escape!',
        },
        { discountValue },
      ),
      codeName: 'FLYWITHUS',
      urlPath: '/search',
      promoDisplayId: '',
      displayMode: 'persistence',
      authState: 'logged_in_and_out',
      displayOptionKey: '',
      delayDuration: 1,
      needsOfferCheck: true,
      expiresAt: '',
      passOfferCheck: {},
    }], // Sri Lanka
  ])
  const configMatchId = Array.from(overrideDestinationIds.keys()).find((id) => query?.includes(`destinationId=${id}`))
  const overridePromoDisplayPrompt: App.PromoDisplayConfig | undefined =
    path.startsWith('/gb/search') &&
    configMatchId ? overrideDestinationIds.get(configMatchId) : undefined
  // if there is a referral code, then we do not show the Promo Display Prompt
  const referralCode = new URLSearchParams(query).get('referralCode')
  if (referralCode) {
    return undefined
  }
  return overridePromoDisplayPrompt
}

export default getOverridePromoDisplayPrompt
